import React, { useState, useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { IonRow, IonCol, IonBadge, IonIcon, IonAlert } from "@ionic/react";
import { useTranslation } from "react-i18next";

import "./AccordionComponent.scss";
import DoctorCard from "../../../../components/Shared/DoctorList/Components/DoctorCard/doctor-card";
import { CONSTANTS } from "../../../../constants";
import { doctorListInputData } from "../../../../components/Shared/DoctorList/doctor-list.model";
import _ from "lodash";
import { rolePermissionsService } from "../../../../services/rolePermissions.service";
import { close, personAddOutline } from "ionicons/icons";
import { utilService } from "../../../../services/utilService";
import { scheduleListService } from "../../../../components/Shared/SelectSchedule/SelectSchedule.service";
import { submitScheduleListRes } from "../../../../components/Shared/SelectSchedule/Models/SubmitScheduleList.model";
import {
  AddedGroup,
  OwnGroup,
} from "../../../../components/Shared/SelectSchedule/Models/SelectScheduleList.model";
import { selectScheduleActions } from "../../../../redux/actions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import TeamCreation from "../../../../components/Shared/TeamsCreationModal/TeamCreationModal";
import { setTeamCreation } from "../../../../components/Shared/TeamsCreationModal/TeamCreationModal.service";
import { useToast } from "@agney/ir-toast";
import { useNetwork } from "../../../../helpers/NetworkContext";
interface accordionProps {
  accordionList: any;
  selectScheduleData?: any;
  isFromTeams?: any;
  isFromUserCard?: boolean;
  userUnLinked?: any;
  editTeam?: any;
  isFromCaseHistoryDetails?: any;
}

const AccordionComponent: React.FC<accordionProps> = (props) => {

  const [activeIndex, setActiveIndex]: any = useState(null);
  const [scheduleList, setScheduleList]: any = useState([]);
  const [scheduleResponse, setScheduleResponse]: any = useState([]);
  const [ownGroupList, setOwnGroupList]: any = useState([]);
  const [doctorListInput, setDoctorListInput]: any = useState({});
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [selectScheduleData, setSelectScheduleData]: any = useState([]);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [scheduleListItemToDelete, setScheduleListItemToDelete]: any = useState(
    []
  );
  const [teamJoinModal, enableTeamJoinModal] = useState(false);
  const [teamEditModal, enableTeamEditModal] = useState(false);

  const [selectedTeamId, setSelectedTeamId]: any = useState();
  const [selectedTeamData, setSelectedTeamData]: any = useState();

  const [isShowUnlinkAlert, SetIsShowUnlinkAlert] = useState(false);
  const [itemToDelete, setItemToDelete]: any = useState();
  const { t } = useTranslation("home");

  const Toast = useToast();
  let history = useHistory();
  const { selectedNetwork } = useNetwork()

  console.log(selectedNetwork,utilService.getNetwork(), "12345")
  const onClick = (itemIndex: any) => {
    let _activeIndex = activeIndex ? [...activeIndex] : [];

    if (_activeIndex.length === 0) {
      _activeIndex.push(itemIndex);
    } else {
      const index = _activeIndex.indexOf(itemIndex);
      if (index === -1) {
        _activeIndex.push(itemIndex);
      } else {
        _activeIndex.splice(index, 1);
      }
    }

    setActiveIndex(_activeIndex);
  };
  var finalAddedGroup: Array<AddedGroup>;
  var finalOwnGroup: Array<OwnGroup>;
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.accordionList) {
      setAccordion();
      setDoctorListInputData();
    }
  }, [props.accordionList]);

  useEffect(() => {
    if (!_.isEmpty(scheduleListItemToDelete)) {
      setIsShowAlert(true);
    }
  }, [scheduleListItemToDelete]);

  useEffect(() => {
    setSelectScheduleData(props.selectScheduleData);
  }, [props.selectScheduleData]);

  useEffect(() => {
    if (!_.isEmpty(scheduleList)) {
      // to open all accordions by default
      const scheduleIndexArray: any = [];
      scheduleList.forEach((scheduleListItem: any, index: any) => {
        scheduleIndexArray.push(index);
      });
      setActiveIndex(scheduleIndexArray);
    }
  }, [scheduleList]);

  const setAccordion = () => {
    const ownGroupList = props.accordionList?.own
      ? Object.keys(_.cloneDeep(props.accordionList?.own))
      : [];
    const scheduleResponse = {
      ...props.accordionList?.own,
      ...props.accordionList?.added,
    };
    SetScheduleBadgeCount(scheduleResponse);
    setOwnGroupList(ownGroupList);
    setScheduleResponse(scheduleResponse);
  };

  const SetScheduleBadgeCount = (scheduleResponse: any) => {
    if (!_.isEmpty(scheduleResponse)) {
      let ScheduleResponseArray = Object.keys(scheduleResponse).map(
        (key: any) => {
          return {
            scheduleName: key,
            scheduleDoctorList: scheduleResponse[key].data,
            scheduleBadgeCount: scheduleResponse[key].data.length,
            scheduleId: scheduleResponse[key].scheduleId,
            id: key,
            ownTeam: scheduleResponse[key].ownTeam,
            teamAdmin: scheduleResponse[key].teamAdmin,
            teamSiteId: scheduleResponse[key].teamSiteId,
            teamStartDate: scheduleResponse[key].teamStartDate,
            teamStartTime: scheduleResponse[key].teamStartTime,
            teamExpiryDate: scheduleResponse[key].teamExpiryDate,
            teamExpiryTime: scheduleResponse[key].teamExpiryTime,
            teamName: scheduleResponse[key].teamName,
          };
        }
      );
      if (props.isFromTeams) {
        setScheduleList(ScheduleResponseArray);
      } else {
        // sorting array based on providers on call length
        ScheduleResponseArray.sort(
          (arrayItem1: any, arrayItem2: any) =>
            arrayItem2.scheduleBadgeCount - arrayItem1.scheduleBadgeCount
        );
        setScheduleList(ScheduleResponseArray);
      }
    } else {
      setScheduleList([]);
    }
  };

  const setDoctorListInputData = () => {
    const doctorListInput: doctorListInputData = {
      componentName: CONSTANTS.COMPONENTS.HOME,
      isMultiSelectEnabled: false,
      isShowColorBadge: false,
    };
    setDoctorListInput(doctorListInput);
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  };

  const isOwnGroup = (scheduleName: string) => {
    if (ownGroupList && ownGroupList.length !== 0) {
      return ownGroupList.indexOf(scheduleName) !== -1 ? true : false;
    } else {
      return false;
    }
  };

  const handleScheduleItemDelete = (scheduleListItem: any) => {
    let tempSelectScheduleData: any = [...selectScheduleData];
    _.remove(tempSelectScheduleData, {
      id: scheduleListItem.scheduleId,
    });
    setSelectScheduleData(_.cloneDeep(tempSelectScheduleData));
    submitFinalScheduleList(tempSelectScheduleData);
  };

  async function submitFinalScheduleList(scheduleData: any) {
    const params: any = getSubmitParams(scheduleData);
    const respSubmitScheduleListResult: submitScheduleListRes =
      await scheduleListService.getRequestCoverageSubmitScheduleList(params);
    if (respSubmitScheduleListResult.isSuccess) {
      if (respSubmitScheduleListResult.result) {
        const addedArray = getAddedArray(finalAddedGroup);
        const ownArray = getOwnArray(finalOwnGroup);
        let concatArray = _.concat(ownArray, addedArray);
        // Storing data to redux
        scheduleListService.selectedScheduleData = concatArray;
        dispatch(selectScheduleActions.getSelectScheduleData(concatArray));
      }
    } else {
      console.log("error");
      scheduleListService.handleErrorResponse();
    }
  }

  const getAddedArray = (resultVal: Array<AddedGroup>) => {
    return _.map(resultVal, (o) => _.extend({ type: "ADD" }, o));
  };

  const getOwnArray = (resultVal: Array<OwnGroup>) => {
    return _.map(resultVal, (o) => _.extend({ type: "OWN" }, o));
  };

  const getSubmitParams = (finalList: any) => {
    return {
      added_groups: getFinalAddedGroupIds(finalList),
      own_groups: getFinalOwnGroupIds(finalList),
      reg_code: utilService.getNetwork(),
      selected_added_groups: getFinalSelectedAddedGroupIds(finalList),
      selected_own_groups: getSelectedFinalOwnGroupIds(finalList),
    };
  };
  const getFinalSelectedAddedGroupIds = (finalList: Array<OwnGroup>) => {
    const selectedAddedGroupIds: any = [];
    finalList.forEach((selectedItem: OwnGroup) => {
      if (selectedItem.type !== "OWN" && selectedItem.isSelected) {
        selectedAddedGroupIds.push(selectedItem.id);
      }
    });
    return selectedAddedGroupIds;
  };

  const getSelectedFinalOwnGroupIds = (finalList: Array<OwnGroup>) => {
    const selectedOwnGroupIds: any = [];
    finalList.forEach((selectedItem: OwnGroup) => {
      if (selectedItem.type === "OWN" && selectedItem.isSelected) {
        selectedOwnGroupIds.push(selectedItem.id);
      }
    });
    return selectedOwnGroupIds;
  };
  const getFinalOwnGroupIds = (finalList: Array<OwnGroup>) => {
    const ownGroupIds: any = [];
    finalOwnGroup = [];
    finalList.forEach((selectedItem: OwnGroup) => {
      if (selectedItem.type === "OWN") {
        ownGroupIds.push(selectedItem.id);
        finalOwnGroup.push(selectedItem);
      }
    });
    return ownGroupIds;
  };

  const getFinalAddedGroupIds = (finalList: Array<OwnGroup>) => {
    const addedGroupIds: any = [];
    finalAddedGroup = [];
    finalList.forEach((selectedItem: OwnGroup) => {
      if (selectedItem.type !== "OWN") {
        addedGroupIds.push(selectedItem.id);
        finalAddedGroup.push(selectedItem);
      }
    });
    return addedGroupIds;
  };

  const setColSize = () => {
    if (props.isFromTeams && !props.isFromUserCard) {
      return "3";
    } else if (props.isFromUserCard) {
      return "6";
    } else {
      return "6";
    }
  };

  const updatedTeamList = (isSuccess: any) => {
    if (isSuccess) {
      const updateLinked = props.userUnLinked
        ? props.userUnLinked(isSuccess)
        : "";
    }
  };

  const linkUsersToTeam = (selectedTeamData: any) => {
    history.push({
      pathname: "/client/file-share/addTeammates",
      state: {
        team_name: selectedTeamData.teamName,
        start_date: selectedTeamData.teamStartDate,
        start_time: selectedTeamData.teamStartTime,
        expiry_date: selectedTeamData.teamExpiryDate,
        expiry_time: selectedTeamData.teamExpiryTime,
        team_id: selectedTeamData.scheduleId,
      },
    });
  };

  const editSelectedTeam = (selectedTeamData: any) => {
    enableTeamEditModal(true);
    setSelectedTeamId(selectedTeamData.scheduleId);
    setSelectedTeamData(selectedTeamData);
  };

  const joinToTeamModal = (selectedTeamData: any) => {
    enableTeamJoinModal(true);
    setSelectedTeamId(selectedTeamData.scheduleId);
    setSelectedTeamData(selectedTeamData);
  };

  const deleteTeam = async () => {
    let params = getDeleteTeamApiParams();
    const apiResponse = await setTeamCreation.deleteTeam(params);
    if (apiResponse.isSuccess) {
      Toast.success(t("teamDeletedSuccess"));
      props.userUnLinked(true);
    }
  };

  const getDeleteTeamApiParams = () => {
    return {
      reg_code: utilService.getNetwork(),
      user_guid: utilService.getLoggedUserGuid(),
      team_id: itemToDelete,
    };
  };

  return (
    <div className="accordion-wrapper">
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => {
    SetIsShowUnlinkAlert(false);
  }}
  cssClass="fav-delete-alert"
  header={t("confirmation")}
  message={t("deleteTeamConfirmation")}
  buttons={[
    {
      text: t("no"),
      role: "cancel",
      cssClass: "secondary",
    },
    {
      text: t("ok"),
      handler: () => {
        deleteTeam();
        SetIsShowUnlinkAlert(false);
      },
    },
  ]}
/>
      <Accordion
        multiple
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        {scheduleList.map((scheduleListItem: any, index: any) => {
          return (
            <AccordionTab
              key={scheduleListItem.scheduleName}
              header={
                <React.Fragment>
                  <div
                    className={`accordion-header-badge ${isOwnGroup(scheduleListItem.team_name)
                        ? "own-badge"
                        : "added-badge"
                      }
                    ${scheduleListItem.teamAdmin ? "admin-badge" : ""}`}
                  ></div>

                  <div
                    className={`add-users-to-team ${props.isFromUserCard ? "hide-buttons" : ""
                      }`}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      linkUsersToTeam(scheduleListItem);
                    }}
                    hidden={!scheduleListItem.teamAdmin}
                  >
                    <span className="icon-add_users"></span>
                  </div>

                  <div
                    className={`edit-team ${props.isFromUserCard ? "hide-buttons" : ""
                      }`}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      editSelectedTeam(scheduleListItem);
                    }}
                    hidden={!scheduleListItem.teamAdmin}
                  >
                    <span className="icon-edit1"></span>
                  </div>

                 <div
  className={`join-team ${
    !scheduleListItem.ownTeam && props.isFromUserCard
      ? "enable-buttons"
      : ""
  }`}
  onClick={(event) => {
    if (selectedNetwork?.value&&(selectedNetwork?.value !== utilService.getNetwork())) return; // disable condition
    event.stopPropagation();
    event.preventDefault();
    joinToTeamModal(scheduleListItem);
  }}
>
  <IonIcon
  icon={personAddOutline}
  hidden={selectedNetwork?.value&&(selectedNetwork?.value !== utilService.getNetwork()) ? true : false}
/>
</div>
                  <div
                    className={`delete-team ${props.isFromUserCard ? "hide-buttons" : ""
                      }`}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      SetIsShowUnlinkAlert(true);
                      setItemToDelete(scheduleListItem.scheduleId);
                    }}
                    hidden={!scheduleListItem.teamAdmin}
                  >
                    <IonIcon icon={close}></IonIcon>
                  </div>

                  {!isOwnGroup(scheduleListItem.scheduleName) && (
                    <div
                      className="delete-schedule-div"
                      hidden={props.isFromTeams ? true : false}
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        setScheduleListItemToDelete(scheduleListItem);
                        setIsShowAlert(true);
                      }}
                    >
                      <IonIcon icon={close}></IonIcon>
                    </div>
                  )}

                  <IonBadge
                    className="accordian-badge-count"
                    title={t("numberOfProvidersOnCall")}
                  >
                    {scheduleListItem.scheduleBadgeCount}
                  </IonBadge>
                  <span className="tab-header-value">
                    {scheduleListItem.scheduleName}
                  </span>
                </React.Fragment>
              }
            >
              <div className="accordion-content-container">
                <IonRow>
                  {scheduleResponse &&
                    !_.isEmpty(scheduleListItem.scheduleDoctorList) ? (
                    scheduleListItem.scheduleDoctorList.map(
                      (item: any, index: any) => {
                        return (
                          <IonCol
                            size-lg={setColSize()}
                            size="12"
                            key={item.guid}
                          >
                            <DoctorCard
                              isFromGlobalTeamAccordion={false}
                              key={item.guid}
                              numberBadge={item.numberBadge}
                              doctorData={item}
                              getSelectedCards={() => { }}
                              doctorListInputDetails={doctorListInput}
                              rolePermissions={rolePermissions}
                              isFromTeams={props.isFromTeams}
                              updateTeamList={updatedTeamList}
                              isFromUserCard={props.isFromUserCard}
                              teamID={scheduleListItem.scheduleId}
                              teamDetails={scheduleListItem}
                            ></DoctorCard>
                          </IonCol>
                        );
                      }
                    )
                  ) : (
                    <div className="no-results-label">
                      {t("noOnCallProviders")}
                    </div>
                  )}
                </IonRow>
              </div>
            </AccordionTab>
          );
        })}
      </Accordion>

      <TeamCreation
        showModal={teamEditModal}
        teamId={selectedTeamId}
        teamDetails={selectedTeamData}
        teamEdit={teamEditModal}
        fromAccordionUserCard={false}
        updateTeamList={updatedTeamList}
        onOk={() => {
          enableTeamEditModal(false);
        }}
        onCancel={() => {
          enableTeamEditModal(false);
        }}
        fullTeamList={scheduleList}
      ></TeamCreation>

      <TeamCreation
        showModal={teamJoinModal}
        teamId={selectedTeamId}
        teamDetails={selectedTeamData}
        fromAccordionUserCard={true}
        joinToTeam={teamJoinModal}
        updateTeamList={updatedTeamList}
        onOk={() => {
          enableTeamJoinModal(false);
        }}
        onCancel={() => {
          enableTeamJoinModal(false);
        }}
        fullTeamList={scheduleList}
      ></TeamCreation>

    <IonAlert
  isOpen={isShowUnlinkAlert}
  onDidDismiss={() => {
    SetIsShowUnlinkAlert(false);
  }}
  cssClass="fav-delete-alert"
  header={t("confirmation")}
  message={t("deleteTeamConfirmation")}
  buttons={[
    {
      text: t("no"),
      role: "cancel",
      cssClass: "secondary",
    },
    {
      text: t("ok"),
      handler: () => {
        deleteTeam();
        SetIsShowUnlinkAlert(false);
      },
    },
  ]}
/>
    </div>
  );
};

export default AccordionComponent;
